<script setup lang="ts">
import { computed, ref, useSlots } from 'vue';
import { onClickOutside } from '@vueuse/core';
import { UniqueComponentId } from 'primevue/utils';

const props = defineProps<{
    id?: string;
    toggleOnClick?: boolean;
}>();

const id = computed(() => props.id ?? UniqueComponentId('topbar-item-'));

const containerClass = computed(() => ['topbar-item']);

const slots = useSlots();

const hasDropdown = computed(() => !!slots.dropdown);

const dropdownRef = ref<HTMLUListElement | null>(null);
const item = ref<HTMLLIElement | null>(null);

const dropdownActive = ref(false);

function toggle() {
    if (dropdownActive.value) {
        hide();
    } else {
        show();
    }
}

function show() {
    dropdownActive.value = true;
}

function hide() {
    dropdownActive.value = false;
}

onClickOutside(dropdownRef, () => {
    hide();
});

defineExpose({ id, toggle, show, hide, active: dropdownActive });
</script>

<template>
    <li :id="id" ref="item" :class="containerClass">
        <template v-if="hasDropdown">
            <a ref="toggleRef" class="cursor-pointer" @click="toggle">
                <slot />
            </a>
        </template>
        <template v-else>
            <slot />
        </template>

        <ul
            v-if="hasDropdown && dropdownActive"
            ref="dropdownRef"
            style="
                top: 3rem;
                bottom: auto;
                width: 18rem;
                left: auto;
                right: -8rem;
            "
            class="topbar-item-dropdown topbar-menu active-topbar-menu"
        >
            <slot name="dropdown" />
        </ul>
    </li>
</template>

<style lang="scss">
.topbar-item {
    > ul {
        z-index: 5;
    }

    .topbar-item-dropdown {
        padding: 0 !important;
        li {
            margin: 0px !important;
            display: flex;
            padding: 1rem;

            &:hover {
                background-color: var(--surface-ground);
            }
        }
    }
}
</style>
